/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { PageContentMessage } from "../../../messages";
import { VApplication } from "../../../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DETAILED_NODE } from "../../../graphql";

const MODULE_NAME =
  "services.CollectionPageService.machines.GetPageContent.state.getPageContentFromServer";
const log = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export const getPageContentFromServer = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      console.log(`content from server`)
      const res = await client?.query({
        query: GET_DETAILED_NODE,
        variables: {
          "tree": "STUDENT_PORTFOLIO",
          input: {
            childrenFilter:{
              state:["SHOWCASED"]
            },
            filter: {
              uuid: msg?.collectionId
            },
            offset: msg?.offset,
            size: msg?.size,
          },
        },
        fetchPolicy: "network-only",
      });
      if (res?.data?.getDetailedNodePublic) {
        const result = res?.data?.getDetailedNodePublic;
        msg.node = result?.node;
        msg.ancestors = result?.ancestors;
        msg.children = result?.children;
        return resolve(true);
      }
      const error = "Query result does not have proper formatted values";
      log?.error(MODULE_NAME, "error in getPageContentFromServer", error);
      return reject(error);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in getPageContentFromServer", err);
      return reject(err?.message);
    }
  });
};
